/*
 * @Author: your name
 * @Date: 2020-11-12 09:47:58
 * @LastEditTime: 2021-06-29 09:16:41
 * @LastEditors: Do not edit
 * @Description: In User Settings Edit
 * @FilePath: \FullPhotoViewer\src\config\index.js
 */
export default {
    baseUrl: {
        // dev: 'http://localhost:8080',
        // pro: 'https://uat-720.ihomecloud.com.cn' // 内测环境
        pro: 'https://720.ihomecloud.com.cn' // 正式环境
        // pro: 'https://720.ihomecloud.com.cn/' // 正式环境(新)
    },
    // 将原来的 /xr(后端是.net) 接口改为  /render(后端是java)接口
    addUrl: {
        pro: '/render/Project/GetTaskInfosByDateAndTokenIdPage'
        // pro: 'https://uat-api.ihomecloud.com.cn/render/Project/GetTaskInfosByDateAndTokenIdPage' // 内测环境
        // pro: 'https://api.ihomecloud.com.cn/render/Project/GetTaskInfosByDateAndTokenIdPage' // 正式环境
        // pro: 'https://720.ihomecloud.com.cn/render/Project/GetTaskInfosByDateAndTokenIdPage' // 正式环境(新)
    },
    // 上传音乐时的免责声明
    disclaimer: {
        // disclaimerUrl:'https://uat.ihomecloud.com.cn/agree/disclaimer' // 内测环境
        disclaimerUrl:'https://www.ihomecloud.com.cn/agree/disclaimer' // 正式环境
    }
};



// WEBPACK FOOTER //
// ./src/config/index.js